import "firebase/auth";
import { NavigationBarMenu } from "../../../components/navigation/NavigationBar";
import { OAuth2SignIn } from "./OAuth2SignIn";

export const OAuth2SignInPage = () => {
  return (
    <>
      <NavigationBarMenu title="Log in" />
      <OAuth2SignIn />
    </>
  );
};
